import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { SideNavigationComponent } from '../../components/side-navigation/side-navigation.component';
import { TopNavigationComponent } from '../../components/top-navigation/top-navigation.component';
import { FooterNavigationComponent } from '../../components/footer-navigation/footer-navigation.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [RouterOutlet, NzDividerModule, SideNavigationComponent, TopNavigationComponent, FooterNavigationComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {}
